import { addDoc, arrayUnion, collection, deleteDoc, doc, setDoc, updateDoc } from 'firebase/firestore'
import { db } from '../../assets/connections'
import { getCurrentDate } from '../../assets/validator'
import * as XLSX from "xlsx"

export const deletingPlayer = async (ref, correo) => {
    try {
        await deleteDoc(doc(doc(db, ref), "Jugador", correo))
    } catch (e) {
        console.error("Error deleting player:", e)
        throw e
    }
}

export const bajaJugador = async (ref, data) => {
    try {
        const datos = {
            clases_jugador: [],
            suscripciones_jugador: [
                {
                    suscripcion: "Inscripcion",
                    fecha_pago: "----/--/--",
                    pagado: 0,
                    por_pagar: 0,
                    comentarios: ""
                },
                {
                    suscripcion: "Mensualidad",
                    fecha_pago: "----/--/--",
                    pagado: 0,
                    por_pagar: 0,
                    comentarios: ""
                }
            ],
            asistencias_jugador: 0,
            ranking_jugador: 0,
            fecha_baja: getCurrentDate(),
            fecha_alta: data.fecha_alta,
            categoria_jugador: data.categoria_jugador,
            correo_jugador: data.id,
            edad_jugador: data.edad_jugador,
            nivel_jugador: data.nivel_jugador,
            nombre_jugador: data.nombre_jugador,
            rama_jugador: data.rama_jugador,
            telefono_jugador: data.telefono_jugador,
            ultima_asistencia: data.ultima_asistencia,
            asistencias: []
        }

        await setDoc(doc(doc(db, ref), "JugadorBaja", datos.correo_jugador), datos)
        await deletingPlayer(ref, datos.correo_jugador)
    } catch (e) {
        console.error("Error en baja jugador:", e)
        throw e
    }
}

export const updateAssistances = async (ref, players) => {
    try {
        for (let i = 0; i < players.length; i++) {
            await updateDoc(doc(doc(db, ref), "Jugador", players[i].id), {
                asistencias: []
            })
        }
    } catch (e) {
        console.error("Error updating assistances:", e)
        throw e
    }
}

export const updatingPlayer = async (ref, correo, suscripciones) => {
    try {
        await updateDoc(doc(doc(db, ref), "Jugador", correo), {
            suscripciones_jugador: suscripciones
        })
    } catch (e) {
        console.error("Error updating player:", e)
        throw e
    }
}

export const addPaymentHistory = async (player_ref, paymentData) => {
    try {
        await addDoc(collection(doc(db, player_ref), "HistorialPagos"), paymentData)
    } catch (e) {
        console.error("Error adding payment history:", e)
        throw e
    }
}

export const addNewFinance = async (ref, financeData, fecha) => {
    try {
        await updateDoc(doc(doc(db, ref), "Finanzas", fecha), {
            ingresos: arrayUnion(financeData)
        })
    } catch (e) {
        await setDoc(doc(doc(db, ref), "Finanzas", fecha), {
            ingresos: [financeData],
            egresos: [],
            fecha: fecha
        })
    }
}

export const generateSuscriptionXLSX = async (ref, players, selectedSubName) => {
    const infoReduced = []
    let total = 0

    for (const v of players) {
        const suscripcion_data = v.suscripciones_jugador.filter(s => s.suscripcion === selectedSubName)
        if (suscripcion_data.length === 0) continue

        total += parseInt(suscripcion_data[0].pagado)
        infoReduced.push({
            Correo: v.correo_jugador,
            Nombre: v.nombre_jugador,
            Suscripcion: selectedSubName,
            FechaPago: suscripcion_data[0].fecha_pago,
            PorPagar: suscripcion_data[0].por_pagar,
            Pagado: suscripcion_data[0].pagado
        })

        const currMonth = new Date().getMonth() + 1
        const currYear = new Date().getFullYear()
        const shouldReset = suscripcion_data[0].fecha_pago === "----/--/--" ||
            parseInt(suscripcion_data[0].fecha_pago.split("-")[0]) < currYear ||
            parseInt(suscripcion_data[0].fecha_pago.split("-")[1]) < currMonth

        if (shouldReset) {
            const suscripciones = v.suscripciones_jugador.map(s =>
                s.suscripcion === selectedSubName
                    ? { ...s, pagado: 0, fecha_pago: "----/--/--" }
                    : s
            )

            await updateDoc(doc(doc(db, ref), "Jugador", v.id), {
                suscripciones_jugador: suscripciones
            }).catch(e => {
                console.log("No se actualizo el jugador: " + v.correo_jugador)
            })
        }
    }

    const worksheet = XLSX.utils.json_to_sheet(infoReduced)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Datos")
    XLSX.writeFile(workbook, selectedSubName + ".xlsx")
}

export const handleCreateXLSX = (players, selectedSub) => {
    const data = players.map(v => {
        const newObject = {
            Correo: v.id,
            Nombre: v.nombre_jugador,
            Telefono: v.telefono_jugador,
            FechaNacimiento: v.edad_jugador,
            AltaJugador: v.fecha_alta,
            Rama: v.rama_jugador,
            Nivel: v.nivel_jugador != "" ? v.nivel_jugador : "Sin nivel",
            Categoria: v.categoria_jugador != "" ? v.categoria_jugador : "Sin categoria",
            Ranking: v.ranking_jugador
        }

        if (selectedSub != "Todos") {
            const suscripcion_data = v.suscripciones_jugador.filter(s => s.suscripcion === selectedSub.nombre_suscripcion)
            newObject.Suscripcion = selectedSub.nombre_suscripcion
            if (suscripcion_data.length > 0) {
                newObject.PorPagar = suscripcion_data[0].por_pagar
                newObject.Pagado = suscripcion_data[0].pagado
            }
        }

        return newObject
    })

    if (data.length > 0) {
        const worksheet = XLSX.utils.json_to_sheet(data)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, "Datos")
        XLSX.writeFile(workbook, "JugadoresFiltrados.xlsx")
        return true
    }
    return false
}
